import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, Box, Image, Button } from '@user-portal/wikr-components';

import Modal from 'components/Modal';

import mail from './img/mail.webp';

import { ReminderSuccessModalProps } from './types';

const ReminderSuccessModal = ({ onClose, onSubmit, subscriptionPeriod }: ReminderSuccessModalProps) => {
    const { t } = useTranslation();

    return (
        <Modal
            paddingY={16}
            paddingX={16}
            isOpen
            onClose={onClose}
            withCloseButton
            buttonWithBackground
            dataLocatorContainer="updatingSubscriptionPlanModal"
            dataLocatorCloseButton="updatingSubscriptionPlanCloseButton"
        >
            <Box $paddingTop={44}>
                <Image maxWidth={72} src={mail} alt="mail" center />
                <Text mb={12} type="h5" center>
                    {t('subscription.reminder.success.title')}
                </Text>
                <Text mb={24} center>
                    {t('subscription.reminder.success.subtitleComputed', { subscription: subscriptionPeriod })}
                </Text>
                <Button dataLocator="updatingSubscriptionPlanContinueButton" onClick={onSubmit}>
                    {t('basics.gotIt')}
                </Button>
            </Box>
        </Modal>
    );
};

export default ReminderSuccessModal;
